<template>
  <div :class="[$style['adl-popover']]">
    <div
      :class="[$style['cf-card-ButonsSingle']]"
      :id="'with-multi-sections-trigger' + _uid"
      @click="onOpenDropDown()"
    >
      <span>
        {{ selectedOption.text }}
      </span>
      <mds-icon
        name="caret-down"
        size="small"
        :class="[$style['caretICon']]"
      ></mds-icon>
    </div>

    <mds-popover
      :triggeredBy="'with-multi-sections-trigger' + _uid"
      v-model="toggle"
      width="200px"
    >
      <mds-list-group>
        <mds-list-group-item
          :isRoutable="true"
          :collapsible="false"
          @click.native="onChangeOption(dataOption)"
          v-for="dataOption in options"
        >
          <span
            :class="
              selectedOption.value == dataOption.value
                ? [$style['activelistcard']]
                : []
            "
          >
            <span>{{ dataOption.text }}</span>

            <span
              v-if="value == dataOption.value"
              style="position: absolute; right: 4px; top: 6px"
            >
              <mds-icon
                :class="[$style['activelistsvgcard']]"
                name="check"
                size="small"
              ></mds-icon>
            </span>
          </span>
        </mds-list-group-item>
      </mds-list-group>
    </mds-popover>
  </div>
</template>

<script>
import MdsSelect from "@mds/select";
import MdsPopover from "@mds/popover";
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import MdsIcon from "@mds/icon";

export default {
  name: "AdlMultiplePopOver",
  components: {
    MdsSelect,
    MdsPopover,
    MdsListGroup,
    MdsListGroupItem,
    MdsIcon,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: Number,
    options: Array,
  },
  computed: {
    selectedOption() {
      const { value } = this;
      return this.setSelectedOption(value);
    },
  },
  methods: {
    onChangeOption(selectedOption) {
      this.value = selectedOption.value;
      this.toggle = !this.toggle;
      this.$emit("change", this.value);
    },
    onOpenDropDown() {
      this.toggle = !this.toggle;
    },
    setSelectedOption(value) {
      let text = "";
      let selectedOption = this.options.filter((sr) => sr.value == value);
      if (selectedOption) {
        text = selectedOption[0].text;
      }
      return {
        text: text,
        value: 1,
      };
    },
  },

  data() {
    return {
      optionId: 0,
      toggle: false,
    };
  },
};
</script>
<style scoped lang="scss" module>
@import "@mds/constants";
@import "@mds/typography";
.adl-popover {
  box-sizing: border-box;
  display: flex;
  .cf-card-ButonsSingle {
    @include mds-body-text-m();
  }
}
</style>
